<template>
    <veui-confirm-box
        class="related-issue-box-wrapper"
        :open="isOpen"
        @ok="ok"
        @cancel="cancel"
    >
        <div class="related-issue-box">
            <div class="related-issue-box-menu">
                <div class="related-issue-box-menu-list">
                    <issue-list
                       :selectable="selectable"
                       :selected="selected"
                       :size="5"
                       :allowscrollheight="maxlistheight"
                       @select="select"
                       @not-scroll="notAllowScroll"
                       @process-change="notAllowScroll">
                    </issue-list>
                </div>
            </div>
            <div class="related-issue-box-selected">
                <span>确认关联issue：</span>
                <ol class="related-issue-box-selected-list">
                    <li v-for="list in selectedIssueLists"
                        :key="list.issueId"
                        class="related-issue-box-selected-list-item">
                        <span>#{{list.issueId}}</span>
                        <span class="related-issue-box-selected-list-item-title">
                            {{list.title}}
                        </span>
                        <span class="related-issue-box-selected-list-item-process">
                            {{list.process | matchIssueProcess}}
                        </span>
                    </li>
                </ol>
            </div>
        </div>
    </veui-confirm-box>
</template>

<style lang="less" scoped>
    @import '../../../../assets/less/views/topic-content/official-process/related-issue-box.less';
</style>

<script>
import {ConfirmBox} from 'veui';
import IssueList from '@/views/List/issue-list';
import {throttle} from '@/utils/debounceThrottle';
import {notAllowScroll, scrollToId} from '@/utils/decorate/scroll';

export default {
    props: {
        confirm: {
            'type': Boolean,
            'default': false
        },
        issueType: {
            'type': String,
            'default': ''
        },
        selectedIssueLists: {
            'type': Array,
            'default': () => []
        },
        maxlistheight: {
            'type': Number,
            'default': 0
        }
    },
    components: {
        'veui-confirm-box': ConfirmBox,
        'issue-list': IssueList
    },
    data() {
        return {
            selectable: true
        };
    },
    computed: {
        isOpen: {
            get() {
                return this.confirm;
            },
            set(newVal) {
                return newVal;
            }
        },
        selected: {
            get() {
                this.$emit('ischange');
                return this.selectedIssueLists.map(item => item.issueId);
            }
        }
    },
    methods: {
        notAllowScroll,
        select(selected, item, selectedItems) {
            this.$emit('setSelectIssue', selected, item, selectedItems);
        },
        ok: throttle(function () {
            let query = {
                issueIds: this.selected,
                issueLists: this.selectedIssueLists
            };
            if (this.issueType === 'official') {
                this.$store.dispatch('setOfficialRelatedIssue', query);
                this.$emit('setreply');
                scrollToId('official-step-2');
            }
            else {
                this.$store.dispatch('setTopicRelatedIssue', query);
                scrollToId('official-board', 60);
            }
            this.cancel();
        }),
        cancel() {
            if (this.issueType === 'official') {
                this.$emit('cancel', 'setOfficialRelatedIssue');
            }
            else {
                this.$emit('cancel', 'setRelatedIssue');
            }
        }
    }
};
</script>
